import AuthUser from '../models/AuthUser';
import EncodeUtility from '../utilities/EncodingUtility';

const AuthContext = () => {
    const KEY = 'user';

    const getUser = (): AuthUser => {
        const user = localStorage.getItem(KEY);

        return user ? EncodeUtility.objectFromBase64(user) : null;
    };

    const isAuthenticated = (): boolean => {
        return !!getUser();
    };

    const setUser = (user: AuthUser) => {
        localStorage.setItem(KEY, EncodeUtility.objectToBase64(user));
    };

    const logout = () => {
        localStorage.clear();
    };

    return {
        isAuthenticated,
        getUser,
        setUser,
        logout
    };
};

export default AuthContext();
